<div class="dialog-container">
  <div class="header">
    <p class="white inline-block"><b>Create New Coop (digital vault) Key</b></p>
    <div class="inline-block float-right">
      <button class="uk-button uk-button-nobutton" (click)="closeDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="content" *ngIf="!downloaded && !downloadConfirmed">
    <form [formGroup]="form" (ngSubmit)="downloadNewKeys()" ngNativeValidate>
      <div class="input-containers">
        <div class="inputs">
          <div class="input-container">
            <p>Enter current Coop (digital vault) Key.</p>
          </div>
          <div class="input-container">
            <input
              type="text"
              formControlName="privateKey"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              required
            />
            <div class="label grey">Coop (digital vault) Key*</div>
            <div *ngIf="form.controls.privateKey.touched && form.controls.privateKey.invalid" class="error">
              <div *ngIf="form.controls.privateKey.errors.required">
                {{ errorManager.ERRORS.vault_key_required }}
              </div>
              <div *ngIf="form.controls.privateKey.errors.minlength">
                {{ errorManager.ERRORS.min_3_char_required }}
              </div>
            </div>
            <div class="error" *ngIf="wrongkeyerror">
              <div>
                {{ errorManager.ERRORS.incorrect_key }}
              </div>
            </div>
          </div>
          <div class="input-container uk-text-center">
            <button
              class="uk-button uk-button-primary"
              type="submit"
            >
            Download New Coop (digital vault) Key
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="redownload-loader-container" *ngIf="loading">
      <img src="/assets/images/loader.gif" alt="" />
    </div>
  </div>
  <div class="content" *ngIf="downloaded && !downloadConfirmed">
    <form [formGroup]="form" (ngSubmit)="confirmDownload()" ngNativeValidate>
      <div class="input-containers">
        <div class="inputs">
          <div class="input-container">
            <p>Confirm that you have saved the new Coop (digital vault) Key file on your device where it can be easily accessed in order to open your Coop (digital vault).</p>
          </div>
          <div class="input-container uk-text-center">
            <button
              class="uk-button uk-button-primary"
              type="submit"
            >
            Confirm
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="content" *ngIf="downloaded && downloadConfirmed">
    <form [formGroup]="form" (ngSubmit)="verifyKey()" ngNativeValidate>
      <div class="input-containers">
        <div class="inputs">
          <div class="input-container">
            <p>Copy and paste new Coop (digital vault) Key to verify it.</p>
          </div>
          <div *ngIf="downloaded">
            <div class="input-container">
              <input
                type="text"
                formControlName="privateKey"
                (keydown)="checkAndSetClass($event)"
                (change)="checkAndSetClass($event)"
                (focus)="checkAndSetClass($event)"
                (input)="checkAndSetClass($event)"
                (blur)="checkAndSetClass($event)"
                required
              />
              <div class="label grey">New Coop (digital vault) Key*</div>
              <div *ngIf="form.controls.privateKey.touched && form.controls.privateKey.invalid" class="error">
                <div *ngIf="form.controls.privateKey.errors.required">
                  {{ errorManager.ERRORS.vault_key_required }}
                </div>
                <div *ngIf="form.controls.privateKey.errors.minlength">
                  {{ errorManager.ERRORS.min_3_char_required }}
                </div>
                <div *ngIf="form.controls.privateKey.errors.invalid">
                  {{ errorManager.ERRORS.incorrect_key }}
                </div>
              </div>
            </div>

            <div class="input-container uk-text-center">
              <button
                class="uk-button uk-button-primary uk-button-thin savebutton"
                type="submit"
              >
                Verify Key
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>  
</div>
